import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendPost } from "api/restUtil";
import { useEffect, useState } from "react";
import { getDateToIsoDate, isValidDate, isValidHm } from "js/common";
import BasicInput from "components/input/BasicInput";
import DatePickerInput from "components/input/DatePickerInput";
import TimeInput from "components/input/TimeInput";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns, setInvalid } from "js/requireCheck";
import { getResultMsg } from "js/order";

/**
 * 발송 지연 처리 팝업
 */
function SendDelayModal (props) {

	const { isOpen, onClose, modalId, initData } = props;
	const [delayInfo, setDelayInfo] = useState({});	// 발송 지연 정보

	useEffect(() => {
		if(isOpen && initData) {
			setDelayInfo({...initData});
		};

	}, [isOpen, initData])

	// 상품 발송 지연 정보 변경
	const handleDataChange = (e) => {
		const {name, value} = e.target;
		// let d = {...data};
		// d[name] = value;

		setDelayInfo(prev => ({...prev, [name]: value}));
	}

	// 상품 발송 지연 처리
	const productOrderSendDelay = async () => {
		const preSelector = "#delayDispatchPopup";
		const requiredColumns = ["dispatchDueDt", "dispatchDueTime", "delayedDispatchReason"];
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), delayInfo, preSelector)) return;

		let errDoms = [];
		if(!isValidDate(delayInfo.dispatchDueDt)) {
			const objArr = document.querySelectorAll(preSelector + " [name='dispatchDueDt']");
			errDoms.push(...objArr);
		}
		if(!isValidHm(delayInfo.dispatchDueTime)) {
			const objArr = document.querySelectorAll(preSelector + " [name='dispatchDueTime']");
			errDoms.push(...objArr);
		}
		if(errDoms.length > 0) {
			alert("날짜 또는 시각 형식이 올바르지 않습니다.");
			for(const errDom of errDoms) {
				setInvalid(errDom);
			}
			return;
		}

		const param = {...delayInfo};

		const dispatchDueDate = param.dispatchDueDt + "T" + param.dispatchDueTime;
		delete param.dispatchDueDt;
		delete param.dispatchDueTime;
		param.dispatchDueDate = getDateToIsoDate(dispatchDueDate);

		if(!window.confirm("발송 지연 처리 하시겠습니까?")) return;

		const result = await sendPost("/api/order/dispatchDelay", param);
		if(result.respCode === "SUCCESS") {
			if(result.data.data.successProductOrderIds.length > 0) {
				alert("발송 지연 처리 되었습니다.");
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
			
			onClose(result.data.data.successProductOrderIds.length, result.data.data.failProductOrderInfos.length);
		}
	}
	
	// 발송지연 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(delayInfo, "#delayDispatchPopup");
	}, [delayInfo]);


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={"배송지연 처리 팝업"}
			id={modalId}
		>
			<div className="me-modal" id="delayDispatchPopup">
				<div className="me-modal-container" style={{width: "500px", height: "450px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">발송 지연 처리</h4>
						</div>
						<div className="me-modal-body" style={{overflowY: "auto", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="grid-table" style={{gridTemplateColumns: "1fr 3fr"}}>
								<div className="th required">발송 기한</div>
								<div className="td">
									<div style={{width: "110px", display: "inline-block"}}>
										<DatePickerInput name="dispatchDueDt" value={delayInfo?.dispatchDueDt} onChange={handleDataChange} />
									</div>
									<div style={{width: "45px", display: "inline-block"}}>
										<TimeInput name="dispatchDueTime" value={delayInfo?.dispatchDueTime} onChange={handleDataChange} />
									</div>
								</div>
								
								<div className="th required">지연 사유</div>
								<div className="td">
									<CommonCodeSelect
										item={{col: "delayedDispatchReason"}} 
										onChange={handleDataChange} 
										value={delayInfo?.delayedDispatchReason} 
										defaultLabel="선택" 
										grpCd="DELAYED_DISPATCH_REASON" 
										width={100} 
									/>
								</div>


								<div className="th">상세 사유</div>
								<div className="td">
									<BasicInput item={{col: "dispatchDelayedDetailedReason"}} value={delayInfo?.dispatchDelayedDetailedReason} onChange={handleDataChange} width="" textAlign="left" />
								</div>
							</div>
						</div>
						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={() => onClose(null)} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={() => productOrderSendDelay()} style={{width: "100%"}} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default SendDelayModal;
